import React, { useState } from 'react'
import "../Head/Header.css"
// import resume from "./Niranjan_Salunkhe_Resume.pdf"

const Header = () => {
  //when scroll header at top 
  window.addEventListener("scroll",function(){
    const header=document.querySelector(".header")
    header.classList.toggle("active",window.scrollY>100)
  })
  
  const[Mobile,setMobile]=useState(false)

  //toggle menu
  return (
    <>
      <header className='header'>
       <div className='container d_flex'>
        {/* <div className='logo'>
            <img src={logo} alt="" style={{ width:"80px", height:"80%", borderRadius:"25%"}}/>
        </div> */}

        <div className='navlink'>
            {/* <ul className='link f_flex uppercase'> */}
              <ul className={Mobile ? "nav-links-mobile":"link f_flex uppercase"}onClick={()=>setMobile(false)}>
                <li><a href="#home">home</a></li>
                <li><a href="#features">skills</a></li>
                <li><a href="#portfolio">Projects</a></li>
                <li><a href="#resume">about me</a></li>
               <li><a href="https://drive.google.com/uc?export=download&id=1wYWOG9D9bu_KulJpwuMQc-r8goDkDg2n" onClick={()=>window.open("https://drive.google.com/file/d/1wYWOG9D9bu_KulJpwuMQc-r8goDkDg2n/view?usp=sharing")} download="fw18_1127_Niranjan_Salunkhe_Resume.pdf">Resume</a></li>
                <li><a href="#contact">contact</a></li>
                {/* <li><a href="https://drive.google.com/uc?export=download&id=1wYWOG9D9bu_KulJpwuMQc-r8goDkDg2n">DownLoad-Resume</a></li> */}
              
            </ul>
            <button className="toggle" onClick={()=>setMobile(!Mobile)}>
                {Mobile ?
                <i className='fas fa-times close home-btn'></i>:
                <i className='fas fa-bars open'></i>
              }
                
            </button>
        </div>
       </div>

      </header>
      <section className='demo'></section>
    </>
  )
}

export default Header

// "https://drive.google.com/uc?export=download&id=1wYWOG9D9bu_KulJpwuMQc-r8goDkDg2n"